type ColourScheme = {
  main: string;
  tint: string;
};

export enum CardThemes {
  Green = 'Green',
  Fuchsia = 'Fuchsia',
  Purple = 'Purple',
  Orange = 'Orange',
  Blue = 'Blue',
  Brown = 'Brown'
}

export type ColourSchema = {
  [CardThemes.Green]: ColourScheme;
  [CardThemes.Fuchsia]: ColourScheme;
  [CardThemes.Purple]: ColourScheme;
  [CardThemes.Orange]: ColourScheme;
  [CardThemes.Blue]: ColourScheme;
  [CardThemes.Brown]: ColourScheme;
};

export type ContentListItemProps = {
  icon: any;
  title: any;
  description: any;
  links: any;
  footerLink: any;
  cardTheme: any;
  headingLevel: number;
  editMode: boolean;
};

export type GroupedContentListProps = {
  editMode: boolean;
  fields: {
    children: any;
    description: any;
    footerLink: any;
    heading: any;
    headingLevel: any;
  };
  params: any;
};
